import { useSelector } from 'react-redux';

import { RootState } from '@/utils/store';

const useHasPermission = (...permissions: string[]) => {
  const user = useSelector((state: RootState) => state.auth.user);

  if (!user) {
    return false;
  }

  if (user.role.name === 'Super Admin') {
    return true;
  }

  return !!user.permissions?.find((p) => permissions.includes(p));
};

export default useHasPermission;
